// extracted by mini-css-extract-plugin
export default {"cls1":"sT2SNIOV3oHhcu31Tjzl","cls2":"uD5WshCsvlW4gF15JvTx sT2SNIOV3oHhcu31Tjzl"};